import { ECallingType } from '@cp/pages/CaseDetails/feedbackForm/interfaces/index.type';

export const FIELD_FEEBACK_TYPES = {
  VIEW: 'View',
  FIELD_FEEDBACK: 'fieldFeedback',
  FEEDBACK_DETAILS: 'Feedback Details',
  VIEW_FEEDBACK: 'View Feedback',
  LOCATION_OF_FEEDBACK: 'Location of feedback'
};

export const HIDE_COMMENTS_CALLING_TYPES = [ECallingType.SKIP_TRACING, ECallingType.WHATSAPP_CALL];

export enum SKIP_TRACING_TYPES {
  SKIP_TRACING_CALL = 'SKIP_TRACING_CALL',
  SKIP_TRACING_TEXT = 'SKIP_TRACING_TEXT',
  SKIP_TRACING_OTHERS = 'SKIP_TRACING_OTHERS'
}

export const SKIP_TRACING_TYPES_LABEL = {
  [SKIP_TRACING_TYPES.SKIP_TRACING_CALL]: 'Call',
  [SKIP_TRACING_TYPES.SKIP_TRACING_TEXT]: 'Text',
  [SKIP_TRACING_TYPES.SKIP_TRACING_OTHERS]: 'Others'
};

export const SKIP_TRACING_TYPES_OPTIONS = [
  {
    id: SKIP_TRACING_TYPES.SKIP_TRACING_TEXT,
    label: 'Text',
    value: SKIP_TRACING_TYPES.SKIP_TRACING_TEXT,
    checked: false
  },
  {
    id: SKIP_TRACING_TYPES.SKIP_TRACING_OTHERS,
    label: 'Others',
    value: SKIP_TRACING_TYPES.SKIP_TRACING_OTHERS,
    checked: false
  }
];
